import { memo } from 'react';
import styled from 'styled-components';

import Box from '@/components/common/Box/Box';
import { RequestSummary } from '@/domain/newRequest';
import { FONT_WEIGHT } from '@/globalStyles';

import NoRestriction from './components/NoRestriction';
import WithRestriction from './components/WithRestriction';
import SummaryInfo from './SummaryInfo/SummaryInfo';

interface ISummaryProps {
    className?: string;
    requestSummary?: RequestSummary;
}
const Summary = ({ requestSummary, className }: ISummaryProps) => {
    const { parentWithRestriction } = requestSummary || {};

    return (
        <div className={className}>
            <Box>
                {parentWithRestriction ? (
                    <WithRestriction summary={requestSummary} />
                ) : (
                    <NoRestriction summary={requestSummary} />
                )}
            </Box>
            {requestSummary?.includeNextRange && <SummaryInfo summary={requestSummary.includeNextRange} />}
        </div>
    );
};

const Memoized = memo(Summary);
const Styled = styled(Memoized)`
    & > div {
        padding: 1.25rem 0.9325rem;
    }
    width: 100%;
    h2 {
        font-weight: ${FONT_WEIGHT.medium};
    }
`;

export default Styled;
